import styled from '@emotion/styled';
export const StatisticsContainer = styled.div`
  justify-content: center;
`;
export const OptionList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 12px;
  max-width: 280px;
  margin: 0 auto;
  justify-content: flex-start;
`;
export const Options = styled.li`
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  text-align: left;
  justify-content: flex-start;
`;
